import {CareJourneyStep, CareJourneyDetailsResponse, ModuleType, UserTaskType} from '@/api/dto/care-journey';
import {StepName, Title} from '@/components/pages/tasks/task_edit/progress/TaskEditStep.styles';
import DisplayHelpers from '@/helpers/display_helpers';
import WorkflowStepForm from '@/components/pages/tasks/task_edit/progress/WorkflowStepForm';
import CareJourneyPreReview from '@/components/pages/tasks/task_edit/progress/pre_review/CareJourneyPreReview';

type Props = {
  careJourneyStep: CareJourneyStep;
  careJourneyDetails: CareJourneyDetailsResponse;
  fetching: boolean;
  disabled: boolean;
}

// USER_TASK steps render a custom React component keyed by userTaskType (no SurveyJS/form).
const USER_TASK_COMPONENTS: Record<string, typeof CareJourneyPreReview> = {
  [UserTaskType.CARE_JOURNEY_PRE_REVIEW]: CareJourneyPreReview,
};

export default function WorkflowStep({ careJourneyStep, careJourneyDetails, disabled }: Props) {
  const stepLabel = careJourneyStep.displayLabel ?? DisplayHelpers.humanize(careJourneyStep.stepName);

  switch (careJourneyStep.moduleType) {
  case ModuleType.COMPLETE_FORM:
    return (
      <div>
        <StepName>
          <Title>{stepLabel}</Title>
        </StepName>
        <WorkflowStepForm
          careJourneyStep={careJourneyStep}
          careJourneyDetails={careJourneyDetails}
          disabled={disabled}
        />
      </div>
    );

  case ModuleType.USER_TASK: {
    const UserTaskComponent = careJourneyStep.userTaskType
      ? USER_TASK_COMPONENTS[careJourneyStep.userTaskType]
      : undefined;
    if (!UserTaskComponent) {
      return null;
    }
    return (
      <UserTaskComponent
        // Remount on a different journey or a replacement task so the wizard seeds a fresh form from
        // the new prefill; the key is stable across refetches of the same task so in-progress edits
        // are preserved (CARECO-6167).
        key={`${careJourneyDetails.careJourneyInstanceId}:${careJourneyStep.taskId ?? ''}`}
        careJourneyStep={careJourneyStep}
        careJourneyDetails={careJourneyDetails}
        disabled={disabled}
      />
    );
  }

  case ModuleType.SEND_MESSAGE:
    return (
      <div>
        <StepName>
          <Title>{stepLabel}</Title>
        </StepName>
        {/* TODO: render send message info - https://hbuco.atlassian.net/browse/CARECO-4437 */}
      </div>
    );

  default:
    return null;
  }
}
